{
  "5DayChallenge": "5 Day Challenge",
  "Activities": "Activities",
  "Admin": "Admin",
  "AllMyEvents": "My Events",
  "Brain": "Brain",
  "Browse": "Browse Projects",
  "Builders": "Builders",
  "HubLibrary": "Hub Library",
  "Cancel": "Cancel",
  "CreateNewProject": "Create a New Project",
  "CreateProject": "Create a Project",
  "DashBoard": "Dashboard",
  "FirstChoice": "Contact Us",
  "Groups": "Groups",
  "Home": "Home",
  "Hub": "Hub",
  "Events": "Events",
  "Login": "Log In",
  "Members": "Members",
  "Menu": "Menu",
  "More": "More",
  "MyEvents": "Events",
  "NewProject": "New Project",
  "Notifications": "Notifications",
  "Project": "Project",
  "ProjectBuilders": "Project Builders",
  "ProjectAndBuilders": "Project and Builders",
  "HubOrEvents": "Hub or Events",
  "ProjectPage": "Project Page",
  "Projects": "Projects",
  "Search": "Search",
  "SelectProject": "Select Project",
  "Signup": "Sign Up",
  "SubscriptionExpired": "Your Subscription has Expired",
  "SubscriptionExpiredMessage": "Your access to hub is now limited. Please renew by contacting us.",
  "Team": "Team",
  "addProject": "add project",
  "addTeammate": "add teammate",
  "addToTeam": "add to team",
  "change": "change",
  "changeDefaultProject": "change default project",
  "currentDefault": "Current Default",
  "defaultProjectNote": "Your default project will show up at the top of your nav bar and be automatically open for ease of access.",
  "help": "Help",
  "hideMenu": "hide menu",
  "homeMenu": "Home menu",
  "howitworks": "How it works",
  "logBackIn": "Log Back In",
  "logOut": "Logout",
  "settings": "Settings",
  "signUpFree": "Sign Up Free",
  "switchTo": "switch to",
  "home": "Home",
  "forInnovotors": "For Innovators",
  "contactSales": "Schedule Demo",
  "forOrganizations": "For Organizations",
  "forEducators": "For Educators",
  "about": "About",
  "SeeAll": "See all",
  "blog": "Blog",
  "Language": "Language",
  "Breadcrumb": "Breadcrumb"
}
